import { render, staticRenderFns } from "./TintsSelect.vue?vue&type=template&id=cd756d86&scoped=true&"
import script from "./TintsSelect.vue?vue&type=script&lang=js&"
export * from "./TintsSelect.vue?vue&type=script&lang=js&"
import style0 from "./TintsSelect.vue?vue&type=style&index=0&id=cd756d86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd756d86",
  null
  
)

export default component.exports